import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
// tslint:disable-next-line:no-any
(window as any).IQc = { entity: 'x', ENTITIES: { x: 'x'} };

import { AppHelper } from './AppHelper';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { ArticleActions } from '../actions/ArticleActions';
import { DialogActions } from '../actions/DialogActions';
import { PriceStore } from '../stores/PriceStore';
import { UIHelper } from './UIHelper';
import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { Stats } from './Stats';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { ArticleStore } from '../stores/ArticleStore';
import { PDFMaker } from './PDFMaker';
import { XLSXDocument } from './XLSXDocument';

import utils = egr.wcf.utils;
import eaiws = egr.wcf.eaiws;

export abstract class ArticleListMaker {
    public static share(downloadFormat: ExportFormat): void {
        switch (downloadFormat) {
            case 'EXCEL':
                AppHelper.shareArticleListExcel(false);
                break;
            case 'PDF':
                AppHelper.shareArticleListPDF(false);
                break;
            default:
                break;
        }
    }

    public static download(downloadFormat: ExportFormat): void {
        switch (downloadFormat) {
            case 'EXCEL':
                ArticleListMaker.downloadExcel();
                break;
            case 'PDF':
                ArticleListMaker.downloadPDF();
                break;
            default:
                break;
        }
    }

    public static downloadPDF(): void {
        Stats.sendEvent({
            category: 'Download',
            action: 'download',
            label: 'PDF'
        });

        ViewSettingsActions.withLock<void>(async () => {
            await ArticleActions.updateArticleList(true);
            if (ViewSettingsStore.getBrowser() === 'Safari') {
                await PDFMaker.generatePDFAsBuffer().then((arrayBuffer: ArrayBuffer) => {
                    DialogActions.showDownloadLink(
                        URL.createObjectURL(new Blob([arrayBuffer], {type: 'application/pdf'})),
                        ProjectManagerStore.getProjectName(true) + '.pdf'
                    );
                });
            } else {
                await PDFMaker.downloadPDF();
            }
        });
    }

    public static downloadExcel(): void {
        Stats.sendEvent({
            category: 'Download',
            action: 'download',
            label: 'Excel'
        });
        ViewSettingsActions.withLock(async () => {
            await ArticleActions.updateArticleList(true);
            const xlsx: XLSXDocument = new XLSXDocument(ArticleStore.getState().articleList);
            if (ViewSettingsStore.getBrowser() === 'Safari') {
                const workbook: any = await xlsx.getDocument(UIHelper.showPrices());
                const base64: string = await workbook.outputAsync('base64');
                DialogActions.showDownloadLink(
                    'data:' + XlsxPopulate.MIME_TYPE + ';base64,' + base64,
                    ProjectManagerStore.getProjectName(true) + '.xlsx'
                );
            } else {
                xlsx.downloadDocument(UIHelper.showPrices(), ProjectManagerStore.getProjectName(true) + '.xlsx');
            }
        });
    }

    public static getArticleListHeader(): string {
        const resultArray: Array<string> = [];
        const projectName: string = ProjectManagerStore.getCurrentProjectName('');
        if (!utils.string.isNullOrEmpty(projectName)) {
            resultArray.push(projectName);
        }
        resultArray.push(UIHelper.toDateString(new Date()));
        return resultArray.join(' | ');
    }

    public static getArticleHeader(data: eaiws.basket.ItemProperties): string {
        const outputArray: Array<string> = [];
        if (data.article == null) {
            return '';
        }
        const articleNumber: string | undefined = data.article.useFinalArticleNumber ?
            data.article.finalArticleNumber : data.article.baseArticleNumber;

        if (utils.string.isNotNullOrEmpty(articleNumber)) {
            outputArray.push(articleNumber);
        }

        if (data.article.shortText != null && data.article.shortText !== '') {
            outputArray.push(data.article.shortText);
        }

        return outputArray.join(' | ');
    }

    public static getManufacturerHeader(data: eaiws.basket.ItemProperties): string {
        const outputArray: Array<string> = [];

        if (data.article == null) {
            return '';
        }

        if (data.article.manufacturerName != null) {
            outputArray.push(data.article.manufacturerName);
        }
        if (data.article.seriesId != null) {
            outputArray.push(data.article.seriesId);
        }

        return outputArray.join(' | ');
    }

    public static getPrice(data: eaiws.basket.ItemProperties, fullPrice: boolean): number {
        const tQuantity: number = 1;
        if (data.article == null) {
            return 0;
        }

        let price: number | undefined = data.article.salesPrice;
        if (price == null || utils.string.isNullOrEmpty(data.article.currency)) {
            return 0;
        }
        if (fullPrice && price != null) {
            price = price * tQuantity;
        }
        if (!PriceStore.isCurrencyValid(data.article.currency)) {
            return price;
        }
        return PriceStore.getPrice(price, data.article.currency);
    }

    public static getPriceString(data: eaiws.basket.ItemProperties, fullPrice: boolean): string {
        if (
            data.article == null ||
            data.article.salesPrice == null ||
            utils.string.isNullOrEmpty(data.article.currency) ||
            !PriceStore.isCurrencyValid(data.article.currency)) {
            return '';
        }

        const tQuantity: number = 1;
        if (fullPrice) {
            return PriceStore.getPriceString(data.article.salesPrice * tQuantity, data.article.currency);
        }
        return PriceStore.getPriceString(data.article.salesPrice, data.article.currency);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/ArticleListMaker.ts